<template>
  <div id="subscription-info-error-view" class="container">
    <div class="flex flex-grow-1 alert alert-danger w-100 mb-2">
      <i class="far fa-exclamation-circle mr-2" /> {{ $t('xSomethingWentWrong') }}
    </div>
    <div>
      <p>{{ $t('xUnableToLoadPlanInfo') }}</p>
    </div>
    <b-row class="mt-4">
      <b-col cols="6" class="flex flex-grow-1">
        <b-button
          class="w-100 footer-button"
          variant="secondary"
          @click="navToSupportPage()"
          data-test-hook="subscription-error-contact-support-button"
        >
          {{ $t('xContactSupportUpgrade') }}
        </b-button>
      </b-col>
      <b-col cols="6" class="flex flex-grow-1">
        <b-button
          class="w-100 footer-button"
          variant="warning"
          @click="$emit('retry')"
          data-test-hook="subscription-error-try-again-button"
        >
          {{ $t('xTryAgain') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  emits: ['retry'],
  methods: {
    navToSupportPage() {
      this.$appInsights.trackEvent({
        name: 'click-contact-support-subscription-issue-modal'
      })
      this.$router.push({
        path: `/support`
      })
    }
  }
}
</script>
<style lang="scss">
.footer-button {
  border-radius: 25px;
}
</style>
